import Vue from 'vue'
import store from '@/store'

Vue.filter('choiceName', (code = '', choice) => {
  const { items } = store.getters['choice/codes'](choice)
  if (items) {
    items.map((r) => {
      if (r.code === 'auto_transfer_pending') {
        r.label = '송금 대기'
      }
      return
    })
    return items.find((r) => r.code === code).label
  }
  return null
})
